import {Outlet} from "react-router-dom";
import {useEffect, useRef} from "react";
import {TopNav} from "../TopNav/TopNav";
import {SubNav} from "../SubNav/SubNav";
import styles from "./AppLayout.module.css";

// Layout route (§2 от G2_NAVIGATION_DESIGN.md): рендерира глобалната лента (Ред 1)
// и пътечката + локалните табове (Ред 2), после съдържанието на страницата.
// Рендерира `children` ако са подадени (напр. началния екран за логнат
// потребител на `/`), иначе <Outlet/> за вложените роутове.
export const AppLayout = ({children}) => {
    const navRef = useRef(null);

    // Публикуваме реалната височина на sticky лентата в CSS променлива
    // (--nav-height), за да могат фиксираните елементи (напр. картите
    // Правно/Изчертано на страницата на ползвател) да стоят под нея, а не
    // под нея да се крият. Лентата се пренася на повече редове при тесен
    // екран/много табове, затова се мери динамично.
    useEffect(() => {
        const el = navRef.current;
        if (!el) return;
        const setVar = () =>
            document.documentElement.style.setProperty('--nav-height', `${el.offsetHeight}px`);
        setVar();
        const ro = new ResizeObserver(setVar);
        ro.observe(el);
        window.addEventListener('resize', setVar);
        return () => {
            ro.disconnect();
            window.removeEventListener('resize', setVar);
        };
    }, []);

    return (
        <>
            <div ref={navRef} className={styles.stickyNav}>
                <TopNav/>
                <SubNav/>
            </div>
            {children || <Outlet/>}
        </>
    );
};
